<template>
  <HeaderPopup>
    <div class="demo-accept-popup">
      <div class="popup-image">
        <img class="icon" src="/static/demo-accept-icon.svg" alt="btby.bbbet.click"/>
      </div>
      <div :class="{ 'popup-content': true, 'popup-content-with-shadow': isShowShadow }">
        <div class="title">
          Welcome to Betby Sportsbook Demo
        </div>
        <div class="text" ref="textBlock">
          This is a demo version of the Betby Sportsbook solution (Demo Version) that may be used for solution
          evaluation purposes for prospective business-to-business customers only. Demo Version is an aggregation of
          betting products to demonstrate the possibilities of software solutions and it may not be considered as the
          final product or product distributed by the owner of this website.
          <br/><br/>
          This Demo Version is not intended and may not be used for the end-user experience. No real money deposits can
          be made, no real money winnings can be won, no valid bets can be placed, no end-user accounts may be created
          by use of the Demo Version. Any visualization of deposits or winnings is for demonstration purposes of the
          user interface options that may be available from time to time to prospect B2B customers only.
          This Demo Version is not betting and/or gambling advertisement and is not intended and may not be used for the
          promotion or advertising of betting and/or gambling services to end-users. This Demo Version is intended for
          and may be used only by B2B professionals.
          <br/><br/>
          This Demo Version is not intended for any particular jurisdiction. Provision of betting products shall at all
          times be subject to any applicable law in any particular jurisdiction. The version available as the final
          product in any particular jurisdiction may be subject to changes, certification, and licensing.<br/>Terms and
          conditions apply. For further information: info@betby.com
        </div>
        <button :class="{ button: true, 'button-disabled': isButtonDisabled }" @click="onButtonClick">ACCEPT &
          CONTINUE
        </button>
      </div>
    </div>
  </HeaderPopup>
</template>

<script>
  import HeaderPopup from "./HeaderPopup";

  export default {
    name: "DemoAcceptPopup",
    components: {
      HeaderPopup,
    },
    data() {
      return {
        isShowShadow: true,
        isButtonDisabled: true,
      };
    },
    props: {
      onButtonClick: Function,
    },
    methods: {
      handleTextScroll() {
        const textBlock = this.$refs.textBlock;
        const isScrolledToEnd = Math.abs(textBlock.scrollHeight - textBlock.clientHeight - textBlock.scrollTop) < 12;
        if (isScrolledToEnd) {
          this.isShowShadow = false;
          this.isButtonDisabled = false;
        } else {
          this.isShowShadow = true;
        }
      }
    },
    mounted() {
      document.body.classList.add('scroll-disabled');
      this.$refs.textBlock.addEventListener('scroll', this.handleTextScroll);
      this.handleTextScroll();
    },
    destroyed() {
      document.body.classList.remove('scroll-disabled');
      this.$refs.textBlock.removeEventListener('scroll', this.handleTextScroll);
    },
  }
</script>

<style scoped>
  .demo-accept-popup {
    width: 800px;
    box-sizing: border-box;
    display: flex;
    white-space: normal;
    background: #F9F9F9;
    border-radius: 12px;
    overflow: hidden;
  }

  .popup-image {
    width: 250px;
    min-width: 250px;
    background: #EDF6FF;
    overflow: hidden;
    position: relative;
    z-index: 2;
  }

  .icon {
    position: absolute;
    width: 356px;
    top: calc(50% - 150px);
    left: -36px;
  }

  .popup-content {
    display: flex;
    flex-direction: column;
    padding: 32px;
    color: #172329;
  }

  .popup-content-with-shadow:before {
    content: "";
    z-index: 1;
    position: absolute;
    bottom: 88px;
    left: 0;
    right: 0;
    height: 40px;
    background: linear-gradient(180deg, rgba(249, 249, 249, 0) 0%, #F9F9F9 100%);
    transition: all 0.3s;
  }

  .title {
    font-weight: 600;
    font-size: 18px;
    line-height: 28px;
  }

  .text {
    font-weight: 500;
    font-size: 12px;
    line-height: 180%;
    margin-top: 16px;
    position: relative;
    max-height: calc(100vh - 328px);
    overflow: auto;
  }

  .button {
    margin-top: 16px;
    width: 100%;
    max-width: 290px;
    height: 40px;
    background: #0821ff;
    font-weight: 600;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.03em;
    border-radius: 24px;
    color: #fff;
    transition: all 0.3s;
    cursor: pointer;
    border: none;
  }

  .button:hover {
    opacity: 0.75;
  }

  .button-disabled {
    pointer-events: none;
    background: #C4C9CB;
  }

  @media (max-width: 800px) {
    .demo-accept-popup {
      width: 100%;
      flex-direction: column;
    }

    .popup-image {
      width: unset;
      min-width: unset;
      height: 120px;
      min-height: 120px;
    }

    .icon {
      width: 230px;
      top: -28px;
      left: calc(50% - 120px);
    }

    .popup-content {
      padding: 24px 24px 32px;
      align-items: center;
    }

    .text {
      max-height: calc(100vh - 428px);
    }
  }

  @media (max-width: 600px) {
    .text {
      max-height: calc(100vh - 444px);
    }
    @supports (-webkit-touch-callout: none) {
      .text {
        max-height: calc(100vh - 544px);
      }
    }
  }
</style>
